<template>
  <v-dialog
    v-model="dialog"
    max-width="960"
    scrollable
    persistent
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        Preço manual: {{ category ? category.name : '' }}
        <v-spacer></v-spacer>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              aria-label="Fechar configuração de preço manual"
              v-bind="attrs"
              v-on="on"
              @click="close"
            >
              <v-icon>{{ icons.mdiClose }}</v-icon>
            </v-btn>
          </template>
          <span>Fechar</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <OccupancyPricingEditor
          v-if="draft"
          :value="draft"
          :child-policies="childPolicies"
          mode-key="manual_pricing_mode"
          occupancy-rates-key="manual_occupancy_rates"
          child-rates-key="manual_child_rates"
        />
        <v-text-field
          v-if="draft && draft.manual_pricing_mode !== 'occupancy'"
          v-model.number="draft.manual_price"
          label="Valor único por noite"
          type="number"
          min="0"
          prefix="R$"
          outlined
          dense
          class="mt-4"
        ></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="close"
        >
          Cancelar
        </v-btn>
        <v-btn
          color="primary"
          @click="apply"
        >
          Aplicar configuração
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import OccupancyPricingEditor from '@/components/OccupancyPricingEditor.vue'

export default {
  name: 'ManualPricingDialog',
  components: { OccupancyPricingEditor },
  props: {
    value: { type: Boolean, default: false },
    category: { type: Object, default: null },
    childPolicies: { type: Array, default: () => [] },
  },
  data: () => ({
    draft: null,
    icons: { mdiClose },
  }),
  computed: {
    dialog: {
      get() { return this.value },
      set(value) { this.$emit('input', value) },
    },
  },
  watch: {
    value(open) {
      if (open) this.initialize()
    },
  },
  methods: {
    initialize() {
      const config = this.category?.config || {}
      this.draft = JSON.parse(JSON.stringify({
        ...config,
        manual_pricing_mode: config.manual_pricing_mode || 'flat',
        manual_occupancy_rates: config.manual_occupancy_rates || [],
        manual_child_rates: config.manual_child_rates || [],
      }))
    },
    apply() {
      if (this.draft.manual_pricing_mode === 'occupancy' && !this.draft.manual_occupancy_rates.length) {
        this.$toast.error('Adicione ao menos uma variação de ocupação')

        return
      }
      this.$emit('apply', this.draft)
      this.close()
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
